export const injectRelAttribute = ({
  props: {
    children: {
      props: {
        displayName = ''
      } = {}
    } = {}
  } = {}
}) => displayName === 'Franchise Opportunities' ? 'noopener noreferrer' : undefined
